import * as React from "react";
import {
  Box,
  Card,
  CardContent,
  Chip,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
  Fab,
} from "@mui/material";
import BorderColorIcon from "@mui/icons-material/BorderColor";
import { useNavigate } from "react-router-dom";
import { userType } from "../../types/entitiesModel";

interface AppTableProps {
  data: userType[];
}

const AppTable: React.FC<AppTableProps> = (props: AppTableProps) => {
  const navigate = useNavigate();

  const handleEditUser = (id: number) => {
    navigate(`/admin/users/editUser/${id.toString()}`);
  };

  return (
    <Box>
      <Card variant="outlined">
        <CardContent>
          <Typography variant="h3">Usuarios</Typography>
          <Box
            sx={{
              overflowX: "auto",
              width: "100%",
            }}
          >
            <Table
              aria-label="simple table"
              sx={{
                mt: 3,
                whiteSpace: "nowrap",
              }}
            >
              <TableHead>
                <TableRow>
                  <TableCell>
                    <Typography color="textSecondary" variant="h6">
                      Id
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography color="textSecondary" variant="h6">
                      Nombre
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography color="textSecondary" variant="h6">
                      Email
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography color="textSecondary" variant="h6">
                      Rol
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography color="textSecondary" variant="h6">
                      Estado
                    </Typography>
                  </TableCell>
                  <TableCell align="center">
                    <Typography color="textSecondary" variant="h6">
                      Editar
                    </Typography>
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {props.data.map((user: userType) => (
                  <TableRow key={user.id}>
                    <TableCell>
                      <Typography sx={{ fontSize: "15px", fontWeight: "500" }}>
                        {user.id}
                      </Typography>
                    </TableCell>
                    <TableCell>
                      <Box sx={{ display: "flex", alignItems: "center" }}>
                        <Box>
                          <Typography variant="h6" sx={{ fontWeight: "600" }}>
                            {user.name}
                          </Typography>
                        </Box>
                      </Box>
                    </TableCell>
                    <TableCell>
                      <Typography color="textSecondary" variant="h6">
                        {user.email}
                      </Typography>
                    </TableCell>
                    <TableCell>
                      <Typography color="textSecondary" variant="h6">
                        {user.role}
                      </Typography>
                    </TableCell>
                    <TableCell>
                      <Chip
                        sx={{
                          pl: "4px",
                          pr: "4px",
                          backgroundColor:
                            user.state === "active" ? "green" : "red",
                          color: "#fff",
                        }}
                        size="small"
                        label={user.state}
                      />
                    </TableCell>
                    <TableCell align="center">
                      <Fab
                        color="success"
                        aria-label="edit"
                        sx={{
                          width: 35,
                          height: 35,
                          cursor: "pointer",
                          backgroundColor: "green",
                          "&:hover": {
                            backgroundColor: "darkgreen",
                          },
                        }}
                        onClick={() => {
                          handleEditUser(user.id);
                        }}
                      >
                        <BorderColorIcon
                          sx={{
                            width: 20,
                            height: 20,
                            widhtcolor: "white",
                          }}
                        />
                      </Fab>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </Box>
        </CardContent>
      </Card>
    </Box>
  );
};

export default AppTable;
